export default "__VITE_ASSET__CioD7n1r__"